import { assinaLaudos } from '@/lib/roles';
/**
 * A ação principal da etapa que não liberou (E147.F3): a revisão abre a mesa, a composição abre o
 * laudo, a assinatura e a entrega levam à certificação — que é do certificador da plataforma; para
 * quem não certifica, a tela diz de quem é a vez. A consulta indisponível se resolve no próprio
 * painel, abaixo da tabela.
 */
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui';
import { useCurrentRole } from '@/lib/auth/useCurrentRole';
import { rotaDoDestino } from '@/lib/caso_destino';
import type { AcaoDaEtapa } from '@/lib/conferencia_das_etapas';

import { t } from './textos';

function Ir({ para, texto }: { para: string; texto: string }): JSX.Element {
  return (
    <Button asChild size="sm" variant="secondary">
      <Link to={para}>{texto}</Link>
    </Button>
  );
}

function NaCertificacao(): JSX.Element {
  const { role, isPlatform } = useCurrentRole();
  if (!assinaLaudos(role, isPlatform)) {
    return <p className="text-caption text-fg-muted">{t.aguardaCertificador}</p>;
  }
  return <Ir para="/certificacao" texto={t.acao.certificacao} />;
}

export function AcaoPrincipal({
  acao,
  caseId,
}: {
  acao: AcaoDaEtapa;
  caseId: string;
}): JSX.Element | null {
  switch (acao) {
    case 'mesa':
      return <Ir para={rotaDoDestino('mesa', caseId)} texto={t.acao.mesa} />;
    case 'laudo':
      return <Ir para={rotaDoDestino('laudo', caseId)} texto={t.acao.laudo} />;
    case 'certificacao':
      return <NaCertificacao />;
    default:
      return null;
  }
}
